
/**
 * 
 * @hidden
 */
export enum DataParameterDirection {

    /**
     * 
     */
    Input = 0,

    /**
     * 
     */
    Output = 1,
}
